module.exports = __webpack_public_path__ + "static/media/contact.c2853dce.jpg";